/**
 * Created by eliranm on 10/08/15.
 */
define(function (require) {


    window.lpTag = window.lpTag || {};

    var WebAgentLogger = require('web-agent-assets-js/WebAgentLogger');
    var webAgentUtils = require('web-agent-utils/WebAgentUtils');
    var WidgetViewController = require('web-agent-framework/WidgetViewController');

    var AgentSummaryWidget = WidgetViewController.extend({
        ControllerName: 'AgentSummaryWidget',
        applicationType: 'AgentSummaryWidget',

        LPViewMap: {
            wrapper: '.lpview_agent_summary_wrapper',
            textarea: '.lpview_agent_summary_textarea',
            message: '.lpview_agent_summary_disable_message'
        },

        LPLangMap: {
            textareaPlaceholder: 'agentSummaryTextareaPlaceholder',
            agentSummaryDisabledMessage: 'agentSummaryDisabledMessage'
        },

        initialize: function (options) {
            this.logger = WebAgentLogger.getLogger(this.applicationType);
            this.logger.debug('initializing', 'initialize', options);
            this.logicController = lpTag.WebAgent.logicController;
        },

        events: function () {
            this.logger.debug('binding events', 'events');
            this.bindViewEvents();
        },

        render: function () {
            this.logger.debug('rendering', 'render');
            this.showWidget();
        }
    });

    AgentSummaryWidget.prototype.bindViewEvents = function () {
        this.bindViewEvent({
            selector: this.LPViewMap.textarea,
            DOMEvent: 'blur',
            callback: this.onTextareaBlur
        });
    };

    AgentSummaryWidget.prototype.updateSummary = function (summary, success, error) {
        this.logger.info('updating current agent summary', 'updateSummary');
        this.modelController.setAgentNote({
            conversationId: this.chatId,
            agentNote: summary,
            success: success,
            error: error,
            context: this
        });
    };

    AgentSummaryWidget.prototype.onChatIdChanged = function (data) {
        this.logger.debug('setting chat ID...', 'onChatIdChanged', data);
        var chatId = this.getFirstProperty(data.newValue);
        if (chatId && this.chatId !== chatId) { // split session support
            this.setSummary('');
            this.removeBindings(this.chatId);
            this.chatId = chatId;
            this.setBindings(this.chatId);
            this.isDeleted = this.getModelParam('chats.' + this.chatId + '.isDeleted');
            this.onConvDeletedChanged({newValue: this.isDeleted});
        }
    };

    AgentSummaryWidget.prototype.onAgentChange = function () {
        this.determineVisibility();
    };


    AgentSummaryWidget.prototype.removeBindings = function (chatId) {
        if(chatId){
            this.unbindModel({modelPath: 'chats.' + chatId + '.chatInfo.agentNote',       callback: this.onConversationNoteChanged});
            this.unbindModel({modelPath: 'chats.' + chatId + '.chatInfo.messagingState',  callback: this.onConversationStateChanged});
            this.unbindModel({modelPath: 'chats.' + chatId + '.agentInfo.agentId',        callback: this.onAgentChange  });
            this.unbindModel({modelPath: 'chats.' + chatId + '.isDeleted',                  callback: this.onConvDeletedChanged});
        }
    };
    AgentSummaryWidget.prototype.setBindings = function(chatId){
        if(chatId){
            this.bindModel({modelPath: 'chats.' + chatId + '.chatInfo.agentNote',         callback: this.onConversationNoteChanged});
            this.bindModel({modelPath: 'chats.' + chatId + '.chatInfo.messagingState',    callback: this.onConversationStateChanged});
            this.bindModel({modelPath: 'chats.' + chatId + '.agentInfo.agentId',          callback: this.onAgentChange  });
            this.bindModel({modelPath: 'chats.' + chatId + '.isDeleted',                    callback: this.onConvDeletedChanged});
        }
    };

    AgentSummaryWidget.prototype.isMyConversation = function () {
        var currentAgentId = this.modelController.getModelParam('agent.messagingUserId');
        var assignedAgentId = this.modelController.getModelParam('chats.' + this.chatId + '.agentInfo.messagingUserId');
        return currentAgentId === assignedAgentId;
    };

    AgentSummaryWidget.prototype.onConversationNoteChanged = function (data) {
        // compare with the current value to guard from update on the same value (happens when user sets a new value
        // from this widget's textarea).  setting the value here is used to set the initial value (will also be used
        // in the future for concurrent note updates)
        if (_.has(data, "newValue") && data.newValue !== this.getSummary()) {
            this.setSummary(data.newValue);
        }
    };

    AgentSummaryWidget.prototype.onConversationStateChanged = function (data) {
        this.determineVisibility(data.newValue);
    };

    AgentSummaryWidget.prototype.onTextareaBlur = function (e) {
        this.logger.debug('textarea blur callback invoked', 'onTextareaBlur');
        var summary = this.getSummary();
        this.updateSummary(summary, this.onSummaryUpdateSuccess, this.onSummaryUpdateError);
    };

    AgentSummaryWidget.prototype.onSummaryUpdateSuccess = function (data) {
        this.logger.info('agent summary updated successfully', 'onSummaryUpdateSuccess', data);
    };

    AgentSummaryWidget.prototype.onSummaryUpdateError = function (data) {
        this.logger.error('failed to update agent summary', 'onSummaryUpdateError', data.message);
    };

    AgentSummaryWidget.prototype.determineVisibility = function (state) {
        this.toggleDisableMessage(false);
        if (this.isDeleted) {
            var textareaEl = this.getTextareaElement();
            this.toggleEnabled(true);
            textareaEl.disabled = true;
            this.toggleDisableMessage(true);
        } else {
            var conversationState = state || this.getModelParam('chats.' + this.chatId + '.chatInfo.messagingState');
            var isConversationLocked = this.logicController.isConversationStateLocked(conversationState);
            this.toggleEnabled( this.isMyConversation() && !isConversationLocked);
        }
    };

    AgentSummaryWidget.prototype.toggleEnabled = function (enabled) {
        var wrapperEl = this.getWrapperElement(),
            textareaEl = this.getTextareaElement();
        this.toggleClass(wrapperEl, 'disabled', !enabled);
        textareaEl.readOnly = !enabled;
        textareaEl.disabled = !enabled;
        // todo - get text for when textarea is disabled AND empty
        textareaEl.placeholder = enabled ? this.translate(this.LPLangMap.textareaPlaceholder) : '';
        if (!enabled) {
            this.toggleDisableMessage(false);
        }
    };

    AgentSummaryWidget.prototype.getSummary = function () {
        this.logger.debug('getting agent summary text from textarea', 'getSummary');
        return this.getTextareaValue();
    };

    AgentSummaryWidget.prototype.setSummary = function (summary) {
        this.logger.debug('setting agent summary text to textarea', 'setSummary', summary);
        this.setTextareaValue(summary);
    };

    AgentSummaryWidget.prototype.getTextareaValue = function () {
        return this.getTextareaElement().value;
    };

    AgentSummaryWidget.prototype.setTextareaValue = function (value) {
        this.getTextareaElement().value = value;
    };

    AgentSummaryWidget.prototype.getTextareaElement = function () {
        return this.getFirstElement(this.LPViewMap.textarea);
    };

    AgentSummaryWidget.prototype.getWrapperElement = function () {
        return this.getFirstElement(this.LPViewMap.wrapper);
    };

    AgentSummaryWidget.prototype.getMessageElement = function () {
        return this.getFirstElement(this.LPViewMap.message);
    };

    AgentSummaryWidget.prototype.onConvDeletedChanged = function (data) {
        this.isDeleted = data.newValue;
        this.determineVisibility();
    };

    AgentSummaryWidget.prototype.toggleDisableMessage = function (value) {
        var messageEl = this.getMessageElement();
        if (value) {
            messageEl.textContent = this.translateObj(this.LPLangMap.agentSummaryDisabledMessage, [{key: webAgentUtils.getDataRetentionTime()}]);
            this.addClass(messageEl, 'visible');
        } else {
            messageEl.textContent = '';
            this.removeClass(messageEl, 'visible');
        }
    };

    return AgentSummaryWidget;

});
